export default __webpack_public_path__ + "static/media/Superfast-Delivery.4b107697.png";